import Controller from '@ember/controller'
import { action } from '@ember/object'
import { service } from '@ember/service'
import type WindowService from 'teacher-ui-client/services/window'
import type LoginCardsRoute from 'teacher-ui-client/login-cards/route'

export default class LoginCardsController extends Controller {
  queryParams = ['subscriptionType']

  @service window!: WindowService

  declare model: ModelFor<LoginCardsRoute>

  @action
  doPrint() {
    /**
     * afterprint event is fired after document has started printing OR print preview has been closed
     *
     * NOTE: Firefox fires afterprint way too early (before print preview is closed) - everything works, but it does not
     * close the tab after the print preview is closed. This has been an issue since FF 85, still present in FF 106
     * https://bugzilla.mozilla.org/show_bug.cgi?id=1685011
     * https://bugzilla.mozilla.org/show_bug.cgi?id=1728779
     * https://bugzilla.mozilla.org/show_bug.cgi?id=1663290
     */
    document.title = `login-cards-${this.model.subscriptionType}` // used as part of pdf filename
    this.window.getWindow.addEventListener('afterprint', () => this.window.getWindow.close())
    this.window.getWindow.print()
  }
}

declare module '@ember/controller' {
  interface Registry {
    'login-cards': LoginCardsController
  }
}
